module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0